<template>
  <div style="width: 100%">
    <a-row style="background: #fff">
      <a-col :span="9">
        <div class="heard-div">
          <div class="heard-div-text">画板尺寸</div>
          <div style="width: 75%">
            <Select :project="project" :page="page" @setProjectParams="setProjectParams" ref="select"/>
          </div>
        </div>
      </a-col>
      <a-col :span="2"> </a-col>
      <a-col :span="6">
        <div class="col-width">
          <div 
            class="head-title-icon" 
            @mouseenter="enter" 
            @mouseleave="leave"
            @click="undoPage"
          >
            <div class="returnIcon">
              <img
                :src="enterChange == true ? returnIcon_c : returnIcon"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div
              :class="
                enterChange == true ? 'returnIcon-text-c' : 'returnIcon-text'
              "
            >
              撤销
            </div>
          </div>
          <div
            class="head-title-icon"
            @mouseenter="enter2"
            @mouseleave="leave2"
            @click="redoPage"
          >
            <div class="returnIcon">
              <img
                :src="enterChange2 == true ? redo_c : redo_d"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div
              :class="enterChange2 == true ? 'returnIcon-text-c' : 'redo-text'"
            >
              重做
            </div>
          </div>
          <div
            class="head-title-icon"
            @mouseenter="enter3"
            @mouseleave="leave3"
            @click="clearPage"
          >
            <div class="returnIcon">
              <img
                :src="enterChange3 == true ? empty_c : empty"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div
              :class="
                enterChange3 == true ? 'returnIcon-text-c' : 'returnIcon-text'
              "
            >
              清空
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="1">
        <div class="color-div"></div>
      </a-col>
      <a-col :span="6">
        <div style="display: flex; width: 100%">
          <div
            @click="changeMode('edit')"
            :class="modeType === 'edit' ? 'head_tab-div-c' : 'head_tab-div'"
          >
            编辑模式
          </div>
          <div
            @click="changeMode('preview')"
            :class="modeType === 'preview' ? 'head_tab-div-c' : 'head_tab-div'"
          >
            预览模式
          </div>
          <div
            @click="changeMode('showCode')"
            :class="modeType === 'showCode'? 'head_tab-div-c' : 'head_tab-div'"
          >
            查看代码
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Vue from 'vue';
import {mapState} from 'vuex';
import { PAGE_UNDO_PREFIX, PAGE_REDO_PREFIX } from "@/store/mutation-types";
import Select from "./Select/index.vue";
import bus from '@/utils/Bus';
export default {
  data() {
    return {
      // redoListLength: 0,
      // undoListLength: 0,
      returnIcon: require("@/assets/edit-page/return.png"),
      returnIcon_c: require("@/assets/edit-page/return-c.png"),
      redo: require("@/assets/edit-page/redo.png"),
      redo_c: require("@/assets/edit-page/redo-c.png"),
      redo_d: require("@/assets/edit-page/redo-d.png"),
      empty: require("@/assets/edit-page/empty.png"),
      empty_c: require("@/assets/edit-page/empty-c.png"),
      enterChange: false,
      enterChange2: false,
      enterChange3: false,
      dataList: [
        {
          iphone: "iphone8",
          numPx: "375 × 667",
        },
        {
          iphone: "iphone 11 pro",
          numPx: "375 × 812",
        },
        {
          iphone: "ipad",
          numPx: "810 × 1080",
        },
        {
          iphone: "响应式页面",
          numPx: "1440 × 900",
        },
        {
          iphone: "Apple TV",
          numPx: "1920 × 1080",
        },
      ],
      optGroup: [
        {
          key: "1",
          label: "移动端",
          dataList: [
            {
              iphone: "iphone8",
              numPx: "375 × 667",
            },
            {
              iphone: "iphone 11 pro",
              numPx: "375 × 812",
            },
            {
              iphone: "ipad",
              numPx: "810 × 1080",
            },
            {
              iphone: "响应式页面",
              numPx: "1440 × 900",
            },
            {
              iphone: "Apple TV",
              numPx: "1920 × 1080",
            },
          ],
        },
        {
          key: "2",
          label: "web端",
        },
        {
          key: "3",
          label: "平板",
        },
      ],
    };
  },
  props: {
    modeType:{
      type: String
    },
    project: {
      type: Object,
      default: (() => {})
    },
    page: {
      type: Object,
      default: (() => {})
    }
  },
  components: {
    Select,
  },
  computed: {
    ...mapState(['undoList', 'redoList']),
  },
  methods: {
    getSize(){
      // this.undoListLength = Vue.ls.get(PAGE_UNDO_PREFIX + this.page.id) ? Vue.ls.get(PAGE_UNDO_PREFIX + this.page.id).length : 0
      // this.redoListLength = Vue.ls.get(PAGE_REDO_PREFIX + this.page.id) ? Vue.ls.get(PAGE_REDO_PREFIX + this.page.id).length : 0
      this.$refs.select.getSize()
    },
    setProjectParams(params){
      this.$emit("setProjectParams", params)
    },
    test(node, props) {
      return <xxx />;
    },
    clearPage(){
      bus.$emit('clear-page');
    },
    redoPage(){
      if(this.redoList.length == 0){
        this.$message.warning("无法重做！",1)
        return
      }
      bus.$emit('redo-page');
    },
    undoPage(){
      if(this.undoList.length <= 1){
        this.$message.warning("无法撤销！",1)
        return
      }
      this.undoListLength = this.undoListLength - 1
      bus.$emit('undo-page');
    },
    changeMode(mode) {
      this.$emit('changeMode',mode);
    },
    enter() {
      this.enterChange = true;
    },
    leave() {
      this.enterChange = false;
    },
    enter2() {
      this.enterChange2 = true;
    },
    leave2() {
      this.enterChange2 = false;
    },
    enter3() {
      this.enterChange3 = true;
    },
    leave3() {
      this.enterChange3 = false;
    },
  },
};
</script>

<style scoped>
@import "index.css";
</style>
